import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { formatExperience } from '../../../insfrastructure/utils/object-utils'
import { analytics } from '../../../insfrastructure/services/analytics'
import './styles.sass'

interface JobCardProps {
    job: any
    jobTypes: Record<string, string>
    buttonText?: string
}

const JobCard: React.FC<JobCardProps> = ({ 
    job, 
    jobTypes, 
    buttonText = "Ver detalhes"
}) => {
    const BRLReal = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })

    // Rastrear visualização do card
    useEffect(() => {
        analytics.trackJobView(job.jobpostId);
    }, [job.jobpostId])

    const handleJobClick = () => {
        analytics.trackEvent('click_job_details', 'jobs', job.jobpostId);
        analytics.addBreadcrumb(`Clicked job: ${job.jobTitle.name}`, 'navigation');
    }

    return (
        <div className='job-card'>
            <div className='top-row'>
                <div className='job-info'>
                    <div className='main'>
                        <h3>{job.jobTitle.name}</h3>
                        <p>{job.company.name}</p>
                        <p className='location'>
                            {job.company.city.displayName}
                        </p>
                    </div>
                    <div className='salary'>
                        <p>{job.showSalary && job.salary > 0 ? BRLReal.format(job.salary) : 'A combinar'}</p>
                    </div>
                </div>
                {window.innerWidth > 1000 && (
                    <div className='sign-in'>
                        <Link to={'/offers/' + job.jobpostId + '/details'} onClick={handleJobClick}>
                            <button className='primary'>
                                {buttonText}
                            </button>
                        </Link>
                    </div>
                )}
            </div>
            <div className='bottom-row'>
                <div className='experience'>
                    <p><b>Experiência:</b> {formatExperience(job.minimumExperience)}</p>
                </div>
                <div className='observations'>
                    <p dangerouslySetInnerHTML={{ __html: job.jobDescription }}></p>
                </div>
                <div className='type'>
                    <span>
                        {jobTypes[job.jobType?.toLowerCase()] || job.jobType || 'Efetiva'}
                    </span>
                </div>
            </div>
            {window.innerWidth <= 1000 && (
                <div className='sign-in'>
                    <Link to={'/offers/' + job.jobpostId + '/details'} onClick={handleJobClick}>
                        <button className='primary'>
                            {buttonText}
                        </button>
                    </Link>
                </div>
            )}
        </div>
    )
}

export default JobCard
